import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const fetchMe = async () => {
      try {
        const res = await axios.get('/api/auth/me', { withCredentials: true });
        const role = res.data?.role;
        if (role && role !== 'ANONYMOUS') {
          setIsAuthenticated(true);
          setUser({ email: res.data?.email, role });
        } else {
          setIsAuthenticated(false);
          setUser(null);
        }
      } catch (e) {
        setIsAuthenticated(false);
        setUser(null);
      } finally {
        setLoading(false);
      }
    };
    fetchMe();
  }, []);

  const login = async () => {
    // Redirect to SSO login - use backend URL directly since window.location.href doesn't use proxy
    // In production, use current origin. In development, use REACT_APP_BACKEND_URL if set, otherwise use origin
    // Backend context path is /api, so we append /api/auth/login
    const backendBaseUrl = process.env.REACT_APP_BACKEND_URL || window.location.origin;
    window.location.href = `${backendBaseUrl}/api/auth/login?force=1`;
  };

  const logout = async () => {
    try {
      await axios.post('/api/logout', {}, { withCredentials: true });
    } catch (_) { }
    window.location.href = '/';
  };

  const value = {
    isAuthenticated,
    user,
    login,
    logout,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
